/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
export function useTimeout() {
  var timeoutRef = React.useRef(null);
  var clear = React.useCallback(function () {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);
  var set = React.useCallback(function (callback, ms) {
    clear();
    for (var _len = arguments.length, arg = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      arg[_key - 2] = arguments[_key];
    }
    timeoutRef.current = setTimeout.apply(void 0, [callback, ms].concat(arg));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(function () {
    return clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    clear: clear,
    set: set
  };
}